// import service, { post, get } from 'sk-axios/http.js'

// // import store from '@/store'
// // request拦截器
// service.interceptors.request.use(config => {
//   // Do something before request is sent
//   if (getToken()) {
//     config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
//   }
//   if (location.pathname === '/beta.html') {
//     if (config.data && !config.data.notNeedBeta) {
//       config.baseURL = '/beta'
//     }
//   }
//   return config
// })

import axios from 'axios'
import { MessageBox } from 'element-ui'
import _ from 'lodash'
import { getToken } from 'sky-engine/utils/auth'

import lang from '@/lang'
import store from '@/store'
const TIMEOUT = process.env.TIMEOUT || 60000

const ERROR_TYPE = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS', //
  NO_LOGIN: 'NO_LOGIN',
  MAINTENANCE_MODE: 'MAINTENANCE_MODE',
  NO_AUTHORITY: 'NO_AUTHORITY'
}

export function createAxiosIntance(baseURL) {
  const service = axios.create({
    baseURL: baseURL || process.env.BASE_API, // api的base_url
    timeout: TIMEOUT // 请求超时时间
  })
  applyInterceptors(service)
  return service
}
// 创建axios实例
const service = createAxiosIntance()

export function rosolveBusinessException(response, notificationId = null) {
  const config = response.config
  let shouldNotice = true
  if (config) {
    shouldNotice = config.notification !== false
  }
  let res = response.data
  if (res instanceof ArrayBuffer && res.byteLength <= 2000) {
    try {
      res = JSON.parse(decodeURIComponent(escape(String.fromCharCode.apply(null, new Uint8Array(res)))))
    } catch (error) {
      console.log(error)
    }
  }
  const status = res.code || res.status
  let msg = res.msg || res.message

  let errorMsgNeedScrollbar = false
  if (res.content && _.isArray(res.content.errorArr)) {
    if (res.content.errorArr.length > 2) {
      errorMsgNeedScrollbar = true
    }
    msg = res.content.errorArr
  }

  // 异步消息id记录
  const isTask = res.content && res.content.taskId && res.content.taskName && res.content.taskStatus
  if (isTask) {
    store.dispatch('AddTaskId', res.content.taskId)
  }

  if (!res) {
    throw new Error('response data is correct')
  }
  if (status === ERROR_TYPE.NO_LOGIN || status === ERROR_TYPE.NO_AUTHORITY) {
    store.dispatch('FedLogOut').then(() => {
      window.location.reload()
    })
    return response
  } else if (status === ERROR_TYPE.MAINTENANCE_MODE) {
    store.dispatch('EnterMaintenanceMode')
  } else if (status === ERROR_TYPE.ERROR) {
    if (config) {
      shouldNotice = shouldNotice && config.hasErrorNotification !== false
    }
    shouldNotice &&
      store.dispatch('OpenNotification', {
        message: msg,
        i18n: false,
        option: {
          scrollbar: errorMsgNeedScrollbar
        }
      })
    return Promise.reject(res)
  } else {
    if (config) {
      shouldNotice = shouldNotice && config.hasSuccessNotification !== false
    }
    // const shouldNotice = config.notification !== false && config.hasSuccessNotification !== false;
    // shouldNotice && msg && store.dispatch('OpenNotification', { message: msg, type: 'success', i18n: false });.
    if (shouldNotice && msg) {
      const opt = { message: msg, type: 'success', i18n: false }
      if (notificationId) {
        opt.id = notificationId
      }
      store.dispatch('OpenNotification', opt)
    }
    return response
  }
}

export function applyInterceptors(service) {
  // request拦截器
  service.interceptors.request.use(
    config => {
      // Do something before request is sent
      // if (store.getters.token) {
      //   config.headers['X-Token'] = getToken() // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
      // }
      if (getToken()) {
        config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
      }
      config.headers['requestFrom'] = 'WEB'

      if (!config.notConverData && config.data !== void 0) {
        config.data = JSON.stringify(config.data)
      }
      if (config.headers && !config.headers['Content-Type']) {
        config.headers = config.headers || {}
        config.headers['Content-Type'] = 'application/json'
      }
      return config
    },
    error => {
      // Do something with request error
      store.dispatch('OpenNotification', { message: 'serviceError.0' })
      Promise.reject(error)
    }
  )
  // respone拦截器
  service.interceptors.response.use(rosolveBusinessException, error => {
    console.log('err' + error) // for debug
    const config = error.config
    let shouldNotice = true
    if (config) {
      shouldNotice = config.notification !== false && config.hasErrorNotification !== false
    }

    if (error && error.response && error.response.status !== 401) {
      error.msg = lang.t('serviceError.' + error.response.status)
      shouldNotice && store.dispatch('OpenNotification', { message: error.msg, i18n: false })
    } else if (error && error.response && error.response.status === 401) {
      MessageBox.confirm(lang.t('serviceError.authError'), lang.t('decideGoOut'), {
        confirmButtonText: lang.t('loginAgain'),
        cancelButtonText: lang.t('cancel'),
        type: 'warning'
      }).then(
        () => {
          location.reload()
        },
        () => {}
      )
    } else if (error && error.stack && error.stack.indexOf('timeout') !== -1) {
      shouldNotice && store.dispatch('OpenNotification', { message: 'serviceError.timeout' })
    }
    return Promise.reject(error)
  })
}

export function post(url, data, timeout = TIMEOUT, opt = {}) {
  // const autoRefresh = !!store.getters.refreshTimerId;
  return service({
    url: process.env.AJAX_BASE_API + url,
    method: 'post',
    data: data || {},
    timeout: timeout,
    withCredentials: true,
    ...opt
  })
}

export function get(url, data = {}, timeout = TIMEOUT) {
  if (!_.isObject(data)) {
    throw new Error('data is not object, url is ' + url)
  }
  return service({
    url: process.env.AJAX_BASE_API + url,
    method: 'get',
    params: data,
    timeout: timeout
  })
}

export function actionUpload(url, data) {
  return service({
    baseURL: '',
    url: process.env.AJAX_BASE_API + url,
    fromActionPost: true,
    hasErrorNotification: false,
    method: 'post',
    data: data || {},
    timeout: 60000,
    withCredentials: true,
    notConverData: true
  })
}

export function outerRequest(
  opt = {
    method: 'get',
    url: '',
    data: {}
  }
) {
  console.log(opt.data, 'opt.data')
  const isGet = opt.method.toLowerCase() === 'get'
  let paramStr = ''
  let url = opt.url
  if (isGet) {
    for (let i in opt.data) {
      console.log('i', i)
      paramStr += `${i}=${opt.data[i]}&`
    }
    paramStr = paramStr.substring(0, paramStr.length - 2)
    url = `${url}?${paramStr}`
  }
  return axios({
    method: opt.method,
    url: url,
    data: opt.data
  })
}

export default service
